<template>
  <div class="card">
    <div class="card-body">
      <ValidationObserver ref="step0" v-slot:="{ handleSubmit }" tag="div">
        <form
          v-if="$store.state.dashboard.siteSettings !== null"
          class="needs-validation"
          @submit.prevent="handleSubmit(submitForm)"
        >
          <div class="flex flex-column">
            <div class="col-12">
              <validation-input
                v-model="amount"
                :rules="`required|numeric|min_value:${chargeMinValue}`"
                placeholder="مبلغ مورد نظر را به تومان وارد کنید"
                validation-field-name="مبلغ"
                label="مبلغ به تومان"
              ></validation-input>
            </div>
            <div class="col-12">
              <button
                class="btn btn-success mt-4"
                style="float: left"
                type="submit"
              >
                شارژ کیف پول
              </button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'ChargeWallet',
  computed: {
    chargeMinValue() {
      return parseInt(
        this.$store.state.dashboard.siteSettings.find(
          (x) => x.slug === 'charge_wallet_min_value'
        )['content']
      )
    },
  },
  data() {
    return {
      amount: '',
    }
  },
  mounted() {
    if (this.$route.query.status && this.$route.query.status === 'ok') {
      switch (parseInt(this.$route.query.code)) {
        case 100:
          Swal.fire(
            'موفق!',
            '<p>کیف پول با موفقیت شارژ شد</p>' +
              `<p>مبلغ تراکنش: <span class="bg-success px-2 text-white badge">${this.$helper.formatPrice(
                this.$route.query.amount
              )} تومان</span> </p>` +
              `<p>شماره پیگشیری تراکنش: <span class="bg-warning text-white badge px-2"> ${this.$route.query.ref_id}</span></p>`,
            'success'
          ).then(() => {
            this.$router.replace({
              query: {},
            })
          })
          break
        case 101:
          Swal.fire('خطا!', `تراکنش تکراری است`, 'error')
      }
    }
  },
  methods: {
    submitForm() {
      this.$axios
        .post('wallet/charge/request-payment-url', { amount: this.amount })
        .then((res) => {
          window.open(res.data.payment_url)
        })
    },
  },
}
</script>
